import { arrayContains } from 'utils/arrayContains';
import { VALIDATE_INSURANCE_NUMBER_FAILURE } from 'redux/actions/users/Insurance';
export const isValidateInsuranceNumberFailed = (state) =>
  arrayContains(state.entities.users.failedRequests, [VALIDATE_INSURANCE_NUMBER_FAILURE]);
